import script from "./ChatSettingsRenameGroupConversation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettingsRenameGroupConversation.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettingsRenameGroupConversation.vue?vue&type=style&index=0&id=7bb4d102&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb4d102"]])

export default __exports__